<template>
  <div class="detail-page">
    <van-nav-bar
      title="资源详情"
      left-arrow fixed placeholder
      @click-left="$router.back()"
    />

    <van-skeleton :loading="loading" title :row="5">
      <div v-if="resource">
        <!-- Cover -->
        <div class="detail-cover" @click="resource.coverUrl && previewImage(resource.coverUrl)">
          <img v-if="resource.coverUrl" :src="resource.coverUrl" alt="" />
          <div v-else class="cover-empty">
            <van-icon name="photo-o" size="48" color="#cbd5e1" />
          </div>
          <div class="cover-tag" :class="resource.isPaid ? 'paid' : 'free'">
            {{ resource.isPaid ? '¥' + resource.price : '免费' }}
          </div>
        </div>

        <div class="detail-body">
          <h2>{{ resource.title }}</h2>
          <p class="detail-desc" v-if="resource.description">{{ resource.description }}</p>

          <!-- Has access: show drive link + extract code -->
          <div v-if="resource.driveUrl" class="info-card">
            <div class="info-row">
              <span class="info-label">网盘链接</span>
              <span class="info-value link" @click="openLink(resource.driveUrl)">
                {{ resource.driveUrl }}
              </span>
            </div>
            <div class="info-row">
              <span class="info-label">提取码</span>
              <span class="info-value code">{{ resource.extractCode }}</span>
              <van-button
                size="mini" round
                color="linear-gradient(135deg, #6366f1, #8b5cf6)"
                @click="copyText(resource.extractCode)"
              >
                复制
              </van-button>
            </div>
            <div class="info-action-btn">
              <van-button
                round block
                color="linear-gradient(135deg, #6366f1, #8b5cf6)"
                @click="openLinkAndCopy(resource.driveUrl, resource.extractCode)"
              >
                打开网盘并复制提取码
              </van-button>
            </div>
          </div>

          <!-- Need login -->
          <div v-else-if="resource.needLogin" class="action-card">
            <van-icon name="user-o" size="48" color="#6366f1" />
            <h3>需要登录</h3>
            <p>登录后购买即可查看网盘链接和提取码</p>
            <van-button
              round block
              color="linear-gradient(135deg, #6366f1, #8b5cf6)"
              @click="$router.push('/login?redirect=' + $route.fullPath)"
            >
              去登录
            </van-button>
          </div>

          <!-- Need pay -->
          <div v-else-if="resource.needPay" class="action-card">
            <div class="price-circle">¥{{ resource.price }}</div>
            <h3>付费资源</h3>
            <p>购买后即可查看网盘链接和提取码</p>
            <van-button
              round block
              :loading="buying"
              color="linear-gradient(135deg, #ef4444, #f97316)"
              @click="onBuy"
            >
              立即购买 ¥{{ resource.price }}
            </van-button>
          </div>

          <!-- Blogger info -->
          <div class="blogger-info" v-if="resource.bloggerName" @click="$router.push('/blogger/' + resource.bloggerId)">
            <van-icon name="user-o" size="16" color="#9ca3af" />
            <span>{{ resource.bloggerName }}</span>
            <van-icon name="arrow" size="12" color="#d1d5db" />
          </div>
        </div>
      </div>
    </van-skeleton>
  </div>
</template>

<script>
import { resourceApi, paymentApi } from '../api';
import { ImagePreview } from 'vant';

export default {
  data() {
    return { resource: null, loading: true, buying: false };
  },
  created() { this.fetchDetail(); },
  methods: {
    async fetchDetail() {
      this.loading = true;
      const res = await resourceApi.getDetail(this.$route.params.id);
      this.resource = res.data;
      this.loading = false;
    },
    async onBuy() {
      this.buying = true;
      try {
        const res = await paymentApi.buyResource({
          resourceId: this.resource.id,
          returnUrl: window.location.href
        });
        console.log(res);
        // if (res.data.payUrl) {
        //   window.location.href = res.data.payUrl;
        // }
      } finally { this.buying = false; }
    },
    openLink(url) {
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$toast.success('提取码已复制');
      } catch (e) {
        const input = document.createElement('input');
        input.value = text;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        this.$toast.success('提取码已复制');
      }
    },
    openLinkAndCopy(url, code) {
      this.copyText(code);
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    previewImage(url) {
      ImagePreview([url]);
    }
  }
};
</script>

<style scoped>
.detail-page { min-height: 100vh; background: #f5f7fa; padding-bottom: 32px; }
.detail-cover {
  width: 100%; height: 260px; position: relative;
  background: #f1f5f9; cursor: pointer;
}
.detail-cover img { width: 100%; height: 100%; object-fit: cover; display: block; }
.cover-empty {
  width: 100%; height: 100%;
  display: flex; align-items: center; justify-content: center;
}
.cover-tag {
  position: absolute; top: 12px; right: 12px;
  padding: 4px 14px; border-radius: 14px;
  font-size: 15px; font-weight: 700; color: #fff;
}
.cover-tag.free { background: rgba(16,185,129,0.9); }
.cover-tag.paid { background: rgba(239,68,68,0.9); }

.detail-body { padding: 16px; }
.detail-body h2 {
  font-size: 20px; font-weight: 700; color: #1f2937; margin: 0;
}
.detail-desc {
  font-size: 15px; color: #6b7280; line-height: 1.6; margin: 12px 0;
}

.info-card {
  margin-top: 20px; padding: 18px;
  background: #fff; border-radius: 14px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}
.info-row {
  display: flex; align-items: center; gap: 10px;
  padding: 12px 0; border-bottom: 1px solid #f3f4f6;
}
.info-row:last-of-type { border-bottom: none; }
.info-label { font-size: 13px; color: #9ca3af; flex-shrink: 0; }
.info-value {
  font-size: 14px; color: #1f2937; flex: 1; min-width: 0;
  word-break: break-all; text-align: right;
}
.info-value.link { color: #6366f1; text-decoration: underline; cursor: pointer; }
.info-value.code {
  font-size: 22px; font-weight: 700; color: #6366f1; letter-spacing: 5px;
}
.info-action-btn { margin-top: 16px; }

.action-card {
  margin-top: 24px; padding: 36px 28px; text-align: center;
  background: #fff; border-radius: 14px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}
.action-card h3 {
  font-size: 18px; font-weight: 700; color: #1f2937; margin: 12px 0 4px;
}
.action-card p {
  font-size: 14px; color: #9ca3af; margin: 6px 0 20px;
}
.price-circle {
  width: 72px; height: 72px; border-radius: 50%;
  background: #fef2f2; color: #ef4444;
  display: flex; align-items: center; justify-content: center;
  font-size: 24px; font-weight: 800;
  margin: 0 auto;
}

.blogger-info {
  display: flex; align-items: center; gap: 6px;
  margin-top: 20px; padding: 12px 0;
  font-size: 13px; color: #9ca3af; cursor: pointer;
}
</style>
